import tagService from '../../services/ClassenService/modules/tagService';

const state = {
  tags: [],
  tagsFacets: [],
};

const mutations = {};

const getters = {};

const actions = {
  getTags: ({commit}) => new Promise((resolve, reject) => {
    tagService.getTags()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getTag: ({commit}, tagId) => new Promise((resolve, reject) => {
    tagService.getTag(tagId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateTag: ({commit}, tagId, tagData) => new Promise((resolve, reject) => {
    tagService.updateTag(tagId, tagData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteTag: ({commit}, tagId) => new Promise((resolve, reject) => {
    tagService.deleteTag(tagId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addTag: ({commit}, tagData) => new Promise((resolve, reject) => {
    tagService.addTag(tagData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
